import { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { defaultLanguage, shortLanguages } from 'shared/locale'
import { SliderPlatforms } from 'shared/models/Slider'

import { selectCarousels, selectCarouselsLoading } from 'features/slider/selectors'
import { selectLanguage } from 'features/userSettings/selectors'

export const useGetSlides = ({ pathname, isMobileOrTablet }: { pathname: string; isMobileOrTablet: boolean }) => {
  const carousels = useSelector(selectCarousels, shallowEqual)
  const carouselsLoading = useSelector(selectCarouselsLoading, shallowEqual)
  const lang = useSelector(selectLanguage, shallowEqual)

  const currentSlides = useMemo(
    () =>
      carousels?.[pathname]?.[isMobileOrTablet ? SliderPlatforms.MOBILE : SliderPlatforms.WEB]?.[
        shortLanguages[lang]
      ] ||
      carousels?.[pathname]?.[isMobileOrTablet ? SliderPlatforms.MOBILE : SliderPlatforms.WEB]?.[
        shortLanguages[defaultLanguage]
      ] ||
      [],
    [carousels, lang, isMobileOrTablet, pathname],
  )

  return {
    carouselsLoading,
    currentSlides,
  }
}
